import { EnRouteInventoryFiltersInputSchema } from "@redotech/redo-inventory-common/en-route-inventory/en-route-inventory-filters";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const EnRouteInventoryMetricsSchema_ = z.object({
  totalReturns: z.number(),
  totalItems: z.number(),
  uniqueMerchants: z.number(),
  inTransitItems: z.number(),
  totalValue: z.number(),
});

export const EnRouteInventoryMetricsSchema: z.ZodType<EnRouteInventoryMetrics> =
  EnRouteInventoryMetricsSchema_;
export interface EnRouteInventoryMetrics extends z.infer<
  typeof EnRouteInventoryMetricsSchema_
> {}

export const getEnRouteInventoryMetrics = unaryRpc({
  name: "getEnRouteInventoryMetrics" as const,
  input: EnRouteInventoryFiltersInputSchema,
  output: EnRouteInventoryMetricsSchema,
});
